import React from 'react';
import LazyLoad from 'react-lazyload';

import { YoutubeSolidIcon } from '../Icon';
import { colors } from '@/const/colors';
import { IMAGE_BASE_URL, ZIGTRUCK_YOUTUBE_HOME_URL } from '@/const/url';
import Flicking from '@egjs/react-flicking';

interface YoutubeSectionProps {
  data: youtubeVideo[];
}

const YoutubeSection = ({ data }: YoutubeSectionProps) => {
  const fetchDetail = (url: string) => {
    window.open(url, '_blank');
  };

  const goToYoutubeHome = () => {
    window.open(ZIGTRUCK_YOUTUBE_HOME_URL);
  };

  return (
    <>
      <div className="flex flex-col pb-6 w-full bg-gray-0 max-h-[315px]">
        <div className="px-4 py-[10px] flex items-center gap-[6px]" onClick={goToYoutubeHome}>
          <h2 className="text-[20px] font-semibold text-gray-8">직트럭 유튜브</h2>
          <YoutubeSolidIcon color={colors.gray[8]} width={24} height={24} />
        </div>
        {!!data.length && (
          <Flicking
            align="prev"
            circular={false}
            renderOnlyVisible={true}
            moveType="strict"
            bound={true}
            className="z-0 px-4"
          >
            {data?.map((item, index) => (
              <div
                key={index}
                onClick={() => fetchDetail(item.videoUrl)}
                className="mb-4 mr-2 text-left cursor-pointer w-[154px] h-[140px]"
              >
                <LazyLoad className="relative w-[154px] h-[86px]" offset={100}>
                  <div className="w-[154px] h-[86px] rounded-lg">
                    <img
                      loading="lazy"
                      className="object-cover w-full h-full rounded-lg"
                      src={item?.thumbnailUrl}
                      alt="트럭 사진"
                      style={{ pointerEvents: 'none' }}
                    />
                  </div>
                </LazyLoad>
                <div className="text-gray-8 font-semibold text-[14px] mt-[10px] line-clamp-2">{item.title}</div>
              </div>
            ))}
            <div onClick={goToYoutubeHome} className="mb-4 mr-2 text-left cursor-pointer w-[154px] h-[140px]">
              <div className="w-[154px] h-[86px] rounded-lg">
                <img
                  loading="lazy"
                  className="object-cover w-full h-full rounded-lg"
                  src={`${IMAGE_BASE_URL}/youtube_zigtruck.png`}
                  alt="youtube"
                  style={{ pointerEvents: 'none' }}
                />
              </div>
              <div className="text-gray-8 font-semibold text-[14px] mt-[10px] line-clamp-2">
                직트럭 유튜브에서 더 많은 화물 정보 얻으러 가기
              </div>
            </div>
          </Flicking>
        )}
      </div>
    </>
  );
};

export default YoutubeSection;
